import zhLocale from 'element-ui/lib/locale/lang/zh-CN'; // 引入element语言包

const cn = {
  Multilingual: {
    // 菜单
    transportManagement: '运输管理',
    transportList: '运输列表',
    systemManagement: '系统管理',
    role: '角色管理',
    accountManagement: '账号管理',
    account: '账号',
    accountType: '账号类型',
    transportMonitoring: '运输监控',
    transportOrder: '运单管理',
    groupManagement: '分组管理',
    groupDevice: '分组设备',
    processManagement: '流程管理',
    iceboxProcess: '冰盒流程',
    equipmentManagement: '设备管理',
    deviceList: '传感器',
    deviceName: '传感器名称',
    gatewayList: '网关',
    deviceParameters: '设备参数',
    deviceEvent: '设备事件',
    deviceMonitoring: '设备监控',
    assetData: '资产数据',
    asset: '资产管理',
    warehouseManagement: '仓库管理',
    location: '库位管理',
    refrigeratorManagement: '冰箱管理',
    boxManagement: '箱管理',
    box: '箱子',
    icebox: '冰盒管理',
    iceboxNumber: '冰盒编号',
    iceboxShelf: '冰盒架',
    iceboxPallet: '冰盒托盘',
    vehicleManagement: '车辆管理',
    mobileColdStorageManagement: '移动冷库',
    mobileShelter: '方仓管理',
    alarmManagement: '报警信息',
    alarmInfoManagement: '报警信息管理',
    alarmProjectManagement: '报警项目管理',
    alarmProject: '报警项目',
    companyManagement: '企业管理',
    siteManagement: '站点管理',
    companySms: '企业短信',
    smsRecords: '短信记录',
    companyVoice: '企业语音',
    voiceRecord: '语音记录',
    deviceService: '设备服务',
    deviceType: '设备类型',
    globalConfig: '全局配置',
    operationLog: '操作日志',
    iceboxLog: '冰盒日志',
    userCenter: '用户中心',
    processTime: '流程时间',
    monitoringDevice: '监控设备',
    dataBackup: '数据备份',
    // 界面
    transportationManagement: '运输管理',
    company: '企业',
    pleaseSelectACompany: '请选择企业',
    site: '站点',
    pleaseSelectASite: '请选择站点',
    deviceNumber: '设备编号',
    boxName: '箱名',
    deliveryOrderNumber: '发货单号',
    orderNumber: '订单号',
    combinedOrderNumber: '合并单号',
    shipper: '发货单位',
    carrier: '承运商',
    consignee: '收货单位',
    coldChainTrackingOrder: '冷链跟踪单',
    coldChainTrackingOrderNumber: '冷链跟踪单号',
    deliveryTime: '发货时间',
    pleaseSelectTheStartTime: '请选择开始时间',
    pleaseSelectTheEndTime: '请选择结束时间',
    receivingTime: '收货时间',
    returnTime: '回收时间',
    deviceSerialNumber: '设备序列号',
    waybillNumber: '运单编号',
    orderCreatedTime: '订单创建时间',
    transportOrderNumberCombinedWithOrderNumber: '发货单号合并单号',
    shippingOrderNumber: '发货单号',
    mergeOrderNumber: '合并单号',
    startTime: '开始时间',
    stopTime: '停止时间',
    endTime: '结束时间',
    overtemperatureState: '超温状态',
    returnStatus: '回收状态',
    operation: '操作',
    operationTime: '操作时间',
    exportReport: '导出报告',
    edit: '编辑',
    checkIcebox: '查看冰盒',
    sensorData: '传感器数据',
    modifyTransportTime: '修改发运时间',
    cancel: '取消',
    confirm: '确定',
    noDataYet: '暂无数据',
    reviewSensorData: '传感器数据查看',
    viewSelectedSensorInformationInLineChart: '折线图中查看选中传感器信息',
    groupList: '分组列表',
    realTimeData: '实时数据',
    dataCurve: '数据曲线',
    equipmentTrack: '设备轨迹',
    dataAlarm: '数据报警',
    dataReport: '数据报告',
    enterCompanyNameToSearch: '可输入企业名搜索',
    pleaseEnterAtLeast4CharactersToSearch: '请至少输入4个字符以上搜索',
    onlineStatus: '在线状态',
    transportationStatus: '运输状态',
    temperature: '温度',
    power: '电量',
    wirelessSignal: '无线信号',
    gpsSignal: 'GPS信号',
    gpsSwitch: 'GPS开关',
    humidity: '湿度',
    humidityRange: '湿度范围',
    collectionTime: '采集时间',
    updateTime: '更新时间',
    drawing: '绘图',
    humidityCurve: '湿度曲线',
    pleaseSelectTheDeviceListOnTheLeft: '请选择左侧设备列表',
    tracePlayback: '轨迹回放',
    pleaseSelectTheIntermediateDeviceList: '请选择中间设备列表',
    alarmTime: '告警时间',
    serialNumber: '序列号',
    sensorName: '传感器名',
    alarmType: '告警类型',
    alarmValue: '告警值',
    currentStatus: '当前状态',
    currentDevice: '当前设备',
    queryReportList: '查询报告',
    exportDataReportAccordingToTheTimeOnTheLeft: '按左侧时间导出数据报告',
    timePeriod: '时间段',
    orderStatusFilter: '订单状态筛选',
    addWaybill: '新增运单',
    exportWaybill: '导出运单',
    importWaybillsInBatches: '批量导入运单',
    issuingWarehouse: '发出地库房',
    destinationWarehouse: '目的地库房',
    receivingWarehouse: '接收库房名',
    receipt: '接收证明',
    receiveTime: '接收时间',
    waybillReport: '运单报告',
    modelNo: '型号',
    icePackLaserCode: '冰盒激光码',
    boxLaserCode: '箱激光码',
    laserCode: '激光码',
    sensor: '传感器',
    endTransport: '结束发运',
    startTransport: '开始发运',
    stopTransport: '停止发运',
    duplicatePackagingInformation: '重复打包信息',
    theModelOfTheBox: '箱型号',
    groupName: '分组名称',
    group: '分组',
    maximumTemperature: '最高温度',
    minimumTemperature: '最低温度',
    totalIcebox: '总冰盒',
    precooledTime: '预冷时间',
    boxprecooledTime: '箱预冷时间',
    coldReleasingTime: '释冷时间',
    iceboxToBePrecooled: '待预冷的冰盒',
    iceboxInPrecooling: '预冷中的冰盒',
    preCooledIceBox: '预冷完成的冰盒',
    iceboxInTransport: '运输中的冰盒',
    unrecycledIcebox: '未回收的冰盒',
    inTransport: '运输中',
    transportCompleted: '运输完成',
    toBePreCooled: '待预冷',
    preCooling: '预冷中',
    preCoolingCompleted: '预冷完成',
    coldReleasing: '释冷中',
    coldReleasingCompleted: '释冷完成',
    coldReleasingForTooLong: '释冷过久',
    carrierNumber: '载体编号',
    totalSensors: '总传感器',
    availableSensors: '可用的传感器',
    inServiceSensors: '在运的传感器',
    recyclableSensors: '可回收的传感器',
    deviceAllocation: '设备分配',
    offline: '离线',
    online: '在线',
    calibrationDueDate: '校准到期日期',
    firmwareVersion: '固件版本',
    simNumber: 'SIM卡号',
    siteList: '站点列表',
    remotePowerOff: '远程关机',
    samplingInterval: '采样间隔',
    positioningInterval: '定位间隔',
    communicationInterval: '通信间隔',
    recordingDelay: '记录延时',
    powerAlarmValue: '电量告警值',
    communicationShutdownValue: '关闭通信值',
    accelerationValue: '加速度值',
    sendParameters: '下发参数',
    modifyParametersInBatches: '批量修改参数',
    shutdownInBatches: '批量关机',
    cancelShutdownInBatches: '批量取消关机',
    eventNumber: '事件编号',
    assetNumber: '资产编号',
    assetName: '资产名称',
    assetType: '资产类型',
    warehouse: '仓库',
    storageLocation: '库位',
    refrigerator: '冰箱',
    insulatedBox: '保温箱',
    mobileInsulatedShelter: '方仓',
    mobileColdStorage: '移动冷库',
    vehicle: '车辆',
    assetList: '资产列表',
    realTimeBoundDevice: '实时绑定设备',
    historicalBoundDevice: '历史绑定设备',
    track: '轨迹',
    remainingBattery: '剩余电量',
    wirelessSignalStrength: '无线信号强度',
    gpsSignalStrength: 'GPS信号强度',
    bindingDevice: '绑定设备',
    unbindingDevice: '解除设备',
    duration: '时长',
    capacity: '容量',
    temperatureRange: '温度范围',
    dimensionsLengthWidthAndHeight: '尺寸（长宽高）',
    temperatureZone: '温区',
    warehouseLocation: '库房位置',
    areaType: '区域类型',
    thisLocationIsUsedForIcePackProcess: '该位置用于冰盒流程',
    warningWhenReachingTheLimitRangeWithinPercentage: '达到限度范围边界以内时警告值',
    brand: '品牌',
    addedBoxModel: '新增箱型号',
    boxModel: '箱型号',
    personInCharge: '负责人',
    personInChargePhoneNumber: '负责人电话',
    addedIcePackModel: '新增冰盒型号',
    addedIcePackRack: '新增冰盒架',
    printBarcode: '打印条码',
    print: '打印',
    addedIcePackTray: '新增冰盒托盘',
    barcode: '条形码',
    licensePlate: '车牌',
    alarmNumber: '报警编号',
    restoreToNormalValue: '恢复正常值',
    correctiveMeasures: '整改措施',
    usedToAutomaticallyGenerateDefaultAlarmsForOrders: '用于自动生成订单默认报警',
    addAlarmItems: '新增报警项目',
    alarmName: '项目名称',
    setDefault: '设置默认',
    accountInformation: '账号信息',
    landline: '座机',
    cellPhone: '手机',
    disable: '禁用',
    displayAccordingToOtherAssets: '按其他资产显示',
    displayByASingleIcePack: '按单个冰盒显示',
    type: '类型',
    operator: '操作人',
    remainingSMS: '剩余短信',
    loginDevice: '登录设备',
    sealPattern: '印章图案',
    provinceMunicipality: '省/直辖市',
    province: '省',
    city: '市',
    area: '区',
    locations: '定位地点',
    detailedLocation: '详细地点',
    smsRecharge: '短信充值',
    topUp: '充值',
    return: '返还',
    sms: '短信',
    totalAmountOfSending: '发送总量（条）',
    sendSuccessfully: '发送成功',
    numberOfSmsChargingEntries: '短信计费条数',
    voiceRecharge: '语音充值',
    numberOfVoiceMessage: '语音数量',
    voiceMessageMarginPieces: '语音余量（条）',
    numberOfVoiceBillingItems: '语音计费条数',
    updateServicePeriod: '更新服务期限',
    currentServicePeriod: '当前服务期限',
    increaseServicePeriod: '增加服务期限',
    servicePeriod: '服务期限',
    increasedPeriod: '增加后的期限',
    expiration: '过期',
    configurationTimeOfIcePackProcessTime: '冰盒流程时间配置',
    emailConfiguration: '邮箱配置',
    systemEmailAddress: '系统邮箱地址',
    emailPassword: '邮箱密码',
    emailSendingServerAddress: '邮箱发送服务器地址',
    emailSendingServerPort: '邮箱发送服务器端口',
    noteItIsRecommendedToSendEmailsUsingSslPleaseFillInTheEmailServerAddressAndPortThatSupportsSsl: '注意：建议采取ssl方式发送邮件，请填写支持ssl的邮件服务器地址和端口',
    associatedDevices: '关联设备',
    status: '状态',
    batchDownload: '批量下载',
    delete: '删 除',
    back: '返 回',
    save: '保 存',
    enable: '启用',
    disabled: '禁用',
    fullName: '姓名',
    email: '邮箱',
    password: '密码',
    remark: '备注',
    code: '编号',
    boxType: '箱类型',
    name: '名称',
    address: '地址',
    smsNumber: '短信数量',
    alarm: '报警',
    warning: '预警',
    temperatureAlarm: '温度报警',
    temperatureWarning: '温度预警',
    humidityAlarm: '湿度报警',
    humidityWarning: '湿度预警',
    lowPowerAlarm: '低电报警',
    powerAlarm: '断电报警',
    alarmStrategy: '报警策略',
    device: '设备',
    passwordChange: '不填不会修改原密码',
    pleaseSelectAccountType: '请选择账号类型',
    pleaseChooseATimeZone: '请选择时区',
    pleaseSelectTheAssetType: '请选择资产类型',
    pleaseSelectTheAsset: '请选择资产',
    pleaseSelectTheDevice: '请选择设备',
    pleaseSelectTheDeviceType: '请选择设备类型',
    recoverStatus: '恢复状态',
    recoverTime: '恢复时间',
    recoverValue: '恢复值',
    faculty: '院系',
    weChatReceivesUser: '微信接收用户',
    username: '用户名',
    maxTemp: '最高温度',
    minTemp: '最低温度',
    maxTemp1: '温度1上限',
    minTemp1: '温度1下限',
    maxTemp2: '温度2上限',
    minTemp2: '温度2下限',
    maxTemp3: '温度3上限',
    minTemp3: '温度3下限',
    maxHumidity: '最高湿度',
    minHumidity: '最低湿度',
    maxHumidity1: '湿度1上限',
    minHumidity1: '湿度1下限',
    maxHumidity2: '湿度2上限',
    minHumidity2: '湿度2下限',
    maxHumidity3: '湿度3上限',
    minHumidity3: '湿度3下限',
    sampleInterval: '采样间隔',
    warningInterval: '报警间隔',
    locateInterval: '定位间隔',
    msgInterval: '通信间隔',
    recordDelay: '记录延迟',
    batteryAlarmValue: '电池报警值',
    batteryOff: '关闭通讯值',
    acceleration: '加速度',
    avatar: '头像',
    creating: '创建中',
    created: '已创建',
    createFailed: '创建失败',
    all: '全部',
    notIssued: '未下发',
    issued: '已下发',
    issuing: '下发中',
    receiver: '接收人',
    normal: '正常',
    overtemperature: '超温',
    deviceLogin: '设备登录',
    sealImage: '印章图片',
    contacts: '联系人',
    barCode: '条形码',
    bindTime: '绑定时间',
    unbindTime: '解绑时间',
    timeZone: '时区',
    startTemperature: '起始温度',
    alarmSetting: '报警设置',
    offlineAlarm: '离线报警',
    dimensions: '外部尺寸',
    internalDimensions: '内部尺寸',
    powerSupply: '电源',
    efficiency: '功率',
    buzzerSwitch: '蜂鸣器开关',
    uploadImg: '上传图片',
    oldPassword: '旧密码',
    newPassword: '新密码',
    confirmPassword: '确认密码',
    modifyPersonalInformation: '修改个人信息',
    logout: '退出登录',
    login: '登 录',
    changePassword: '修改密码',
    smartColdChainManagementSystem: '智慧冷链管理系统',
    basicInformation: '基本信息',
    search: '搜索',
    create: '新增',
    accountSetting: '账号设置',
    reset: '重置',
    export: '导出',
    hour: '时',
    cancelDefault: '取消默认',
    totalBox: '总箱子',
    availableBoxes: '可用箱子',
    boxInTransit: '在途箱子',
    recyclableBox: '可回收箱',
    detail: '详情',
    pushApi: '推送API',
    to: '至',
    longitude: '经度',
    latitude: '纬度',
    second: '秒',
    autoRefresh: '自动刷新',
    refreshInterval: '刷新间隔',
    year: '年',
    month: '月',
    day: '天',
    alarmOnceForEachAnomaly: '每次异常立即报警一次',
    theAlarmIsGeneratedOnceFor: '连续异常',
    consecutiveAbnormalTimes: '次报警1次',
    theFirstAndThen: '首次异常立即报警1次，之后连续异常',
    normalReminder: '首次异常报警，恢复正常提醒',
    showGrouping: '显示分组',
    onlyDisplayDevices: '仅显示设备',
    selectAll: '全选',
    iceBoxInfo: '冰盒信息',
    accountInfo: '账号信息',
    wechatBind: '微信绑定',
    pleaseAttention: '请先关注公众号后，再扫描上面二维码进行绑定',
    bindFinish: '绑定完成',
    weChatAlarm: '扫码绑定微信报警',
    preferenceSettings: '偏好设置',
    bindWeChat: '绑定微信',
    unbind: '解 绑',
    alarmInfo: '报警信息',
    check: '查看',
    batchRead: '批量已阅',
    batchRectification: '批量整改',
    refresh: '刷 新',
    searchTrack: '搜索轨迹',
    bindToAsset: '绑定到资产',
    boxInfo: '箱子信息',
    carInfo: '车辆信息',
    coldStoreInfo: '移动冷库信息',
    companyInfo: '企业信息',
    accountAPTInfo: '账号API信息',
    deviceInfo: '设备信息',
    deviceAlarmSetting: '设备报警设置',
    language: '语言',
    pleaseChooseALanguage: '请选择语言',
    iceBoxTypeInfo: '冰盒型号信息',
    iceBoxType: '冰盒型号',
    carrierType: '载体类型',
    overTime: '超过时间',
    remainTime: '剩余时间',
    pleaseEnterYourAccount: '请输入账号',
    pleaseEnterYourPassword: '请输入密码',
    pleaseEnterYourVerificationCode: '请输入验证码',
    orderTime: '下单时间',
    WaybillMonitor: '运单监控',
    waybillInfo: '运单信息',
    systemEmail: '系统邮箱',
    welcome: '欢迎您！',
    // 面包屑
    editAccount: '编辑账号',
    addAccount: '新增账号',
    accountDetail: '账号详情',
    setAccount: '账号设置',
    editAlarmInfo: '编辑报警信息',
    addAlarmInfo: '新增报警信息',
    editBox: '编辑箱子',
    addBox: '新增箱子',
    boxDetail: '箱子详情',
    boxTypeManage: '箱子型号管理',
    editBoxType: '编辑箱子型号',
    addBoxType: '新增箱子型号',
    editVehicle: '编辑车辆',
    addVehicle: '新增车辆',
    vehicleDetail: '车辆详情',
    coldStoreManage: '冷库管理',
    editColdStore: '编辑冷库',
    addColdStore: '新增冷库',
    coldStoreDetail: '冷库详情',
    editCompany: '编辑企业',
    addCompany: '新增企业',
    companyDetail: '企业详情',
    editCompanyAPI: '编辑企业API',
    addCompanyAPI: '新增企业API',
    companySMSRecharge: '企业短信充值',
    companySMSRechargeHistory: '企业短信记录',
    companyVoiceRecharge: '企业语音充值',
    companyVoiceRechargeHistory: '企业语音记录',
    deviceManagement: '设备管理',
    editDevice: '编辑设备',
    addDevice: '新增设备',
    deviceDetail: '设备详情',
    deviceBatchAssign: '批量分配设备',
    gatewayDetail: '网关详情',
    editRefrigerator: '编辑冰箱',
    addRefrigerator: '新增冰箱',
    refrigeratorDetail: '冰箱详情',
    editGroup: '编辑分组',
    addGroup: '新增分组',
    editIceBox: '编辑冰盒',
    addIceBox: '新增冰盒',
    iceBoxDetail: '冰盒详情',
    iceBoxPallet: '冰盒托盘',
    editIceBoxPallet: '编辑冰盒托盘',
    addIceBoxPallet: '新增冰盒托盘',
    iceBoxProcess: '冰盒流程',
    iceBoxShelf: '冰盒架',
    editIceBoxShelf: '编辑冰盒架',
    addIceBoxShelf: '新增冰盒架',
    iceBoxShelfDetail: '冰盒架详情',
    iceboxType: '冰盒型号',
    editIceboxType: '编辑冰盒型号',
    addIceboxType: '新增冰盒型号',
    iceboxTypeDetail: '冰盒型号详情',
    editWarehouse: '编辑仓库',
    addWarehouse: '新增仓库',
    warehouseDetail: '仓库详情',
    log: '日志',
    logDetail: '日志详情',
    editShelter: '编辑方仓',
    addShelter: '新增方仓',
    shelterDetail: '方仓详情',
    editSite: '编辑站点',
    addSite: '新增站点',
    siteDetail: '站点详情',
    config: '配置',
    deviceData: '设备数据查看',
    deviceView: '设备查看',
    editTransportOrder: '编辑运单',
    addTransportOrder: '新增运单',
    transportOrderDetail: '运单详情',
    transportOrderMonitor: '运单监控',
    downloadCenter: '下载中心',
    voiceList: '语音记录',
    pleaseEnterSerialNumber: '请输入序列号',
    pleaseEnterName: '请输入名称',
    pleaseEnterMark: '请输入备注',
    pleaseChooseStatus: '请选择状态',
    pleaseEnterBoxName: '请输入箱子名称',
    pleaseEnterLaserCode: '请输入激光码',
    pleaseEnterCode: '请输入编号',
    pleaseSelectType: '请选择类型',
    pleaseEnterLicensePlate: '请输入车牌号',
    pleaseEnterCompanyName: '请输入企业名称',
    pleaseSelectADeviceType: '请选择设备类型',
    pleaseEnterDeviceName: '请输入设备名称',
    pleaseEnterRFID: '请输入RFID',
    temperatureStatus: '温度状态',
    minimumRefreshInterval: '刷新间隔最小30秒',
    pleaseEnterRefreshInterval: '请输入刷新间隔',
    pleaseEnterYear: '请输入年份',
    pleaseEnterMonth: '请输入月份',
    pleaseEnterDay: '请输入日期',
    pleaseEnterGatewayName: '请输入网关名称',
    checkedByDefault: '默认不勾选为分钟，勾选后面选择框则为秒',
    minAndSecond: '分钟：1-195，秒：10-59',
    minAndSecond2: '分钟：1-65475，秒：10-59',
    valueBetween100And80: '100至80之间数值',
    valueBetween0And100: '0至100之间数值',
    valueBetween1And100: '1至100之间数值',
    valueBetween0And65535: '0至65535之间数值',
    pleaseSelectSampleInterval: '请选择采样间隔',
    pleaseSelectMSGInterval: '请选择通信间隔',
    valueBetween1And1000: '1至1000之间数值',
    valueBetween1And1440: '1至1440之间数值',
    valueBetween0And1440: '0至1440之间数值',
    valueBetween200And1000: '-200至1000之间数值',
    valueBetween200And1400: '-200至1400之间数值',
    valueBetween100And100: '-100至100之间数值',
    upperLimit: '上限',
    lowerLimit: '下限',
    pleaseEnterGroupName: '请输入分组名称',
    pleaseSelectIceBoxType: '请选择冰盒型号',
    iceBoxTypeName: '冰盒型号名称',
    RFIDNumber: 'RFID数量',
    long: '长',
    width: '宽',
    height: '高',
    pleaseSelectOperateType: '请选择操作类型',
    operateType: '操作类型',
    assetCode: '资产编号',
    pleaseEnterAssetCode: '请输入资产编号',
    provinceMunicipalitySpecialAdministrativeRegion: '省/市/特别行政区',
    clickMap: '点击地图获取自动获取定位地点',
    provideDetailedLocationInformation: '请提供详细的地址信息',
    enterDeviceSerialNumberSearch: '输入设备序列号搜索',
    alarmMethod: '报警方式',
    forceNoAlarm: '强制不报警',
    accordingToAlarm: '按照运单中设置的报警',
    pleaseSelectTransportStatus: '请选择运单状态',
    clickToUpload: '点击上传',
    onlyFiles: '只能上传不超过20M的文件',
    pleaseSelect: '请选择',
    sendTime: '发送时间',
    content: '内容',
    voiceNumber: '语音计费条数',
    warehouseInfo: '仓库信息',
    boxTypeInfo: '箱型号信息',
    vehicleInfo: '车辆信息',
    deviceBatchAllocation: '批量分配设备',
    refrigeratorInfo: '冰箱信息',
    iceboxPalletInfo: '冰盒托盘信息',
    iceBoxShelfInfo: '冰盒架信息',
    createSubLocation: '新建子位置',
    editSubLocation: '编辑子位置',
    shelterInfo: '方仓信息',
    pleaseEnterCarrierNumber: '请输入载体编号',
    modifyShippingTime: '修改发货时间',
    deleteDevice: '删除设备',
    batchAlarmSetting: '批量报警设置',
    upperTemperatureLimit: '上限温度',
    lowerTemperatureLimit: '下限温度',
    upperHumidityLimit: '上限湿度',
    lowerHumidityLimit: '下限湿度',
    deleteSelected: '删除所选',
    usedAutomatically: '用于自动生成订单默认报警',
    SMSMargin: '短信余量',
    totalAmountSent: '发送总数',
    sendSuccess: '发送成功',
    items: '条',
    iceBoxLog: '冰盒日志',
    deviceAlarm: '设备离线时报警',
    userInfo: '用户信息',
    uploadImgFile: '只能上传jpg/png文件，且不超过500kb',
    exportType: '导出类型',
    fileStatus: '文件状态',
    download: '下载',
    yes: '是',
    no: '否',
    exportReportInfo: '导出报告信息',
    generating: '生成中',
    generated: '已生成',
    generateFail: '生成失败',
    time: '时间',
    notSupportParameterSettings: '当前类型设备不支持参数设置',
    channel: '通道号',
    channelDetails: '通道详情',
    vibration: '振动',
    vibrationAlarm: '振动报警',
    tilt: '倾斜',
    tiltAlarm: '倾斜报警',
    maxLight: '光照上限',
    minLight: '光照下限',
    lightAlarm: '光照报警',
    remove: '删除',
    strategy: '策略',
    operateTime: '操作时间',
    delayedDuration: '延迟时长',
    seconds: '秒',
    minutes: '分钟',
    pleaseEnterTheReceivingUnit: '请输入收货单位',
    pleaseEnterTheHumidityLowerLimit: '请输入湿度下限',
    pleaseEnterTheHumidityUpperLimit: '请输入湿度上限',
    pleaseSelectTheReceivingUser: '请选择需要接收微信通知的用户',
    pleaseEnterTheRectificationMeasure: '请输入整改措施',
    noData: '无数据',
    unitDefaultToMinutes: '单位默认为分钟，当采样间隔勾选秒时则必须与采样间隔一致，当采样间隔未勾选秒时则应为采样间隔的正整数倍',
    transportOrderNumber: '运单号',
    unitSeconds: '单位秒',
    defaultToMinutes: '默认不勾选为分钟，勾选后面选择框则为秒',
    valueBetweenMinus100And80: '-100至80之间数值',
    max20Characters: '最大20个字符',
    selectDateTime: '请选择日期时间',
    endShipping: '结束发运',
    shippingEnd: '发运结束',
    shippingInProgress: '发运中',
    notShipped: '未发运',
    pleaseSelectTheIssuanceType: '请选择下发类型',
    issuanceType: '下发类型',
    allNodes: '所有节点',
    bindNode: '绑定节点',
    specifiedNode: '指定节点',
    gateway: '网关',
    nodeList: '节点列表',
    nodeList2: '节点列表（一次最大选择20个）',
    issuanceParametersToSpecificNodesMustSelectNodes: '下发参数到指定节点必须选择节点',
    nodeSelectionQuantityCannotBeGreaterThan20CurrentSelectionQuantity: '节点选择数量不能大于20，当前选择数量为',
    brightScreenTime: '亮屏时间',
    normalUploadInterval: '正常上传间隔',
    range1To1440: '范围 [1 ~ 1440]',
    rangeMinus50To85: '范围 [-50 ~ 85]°C',
    associatedFenceCount: '关联围栏数量',
    flightModeDuration: '飞行模式时长',
    exitFlightModeBeforeCommunicationInterval: '退出飞行模式前通信间隔',
    flightModeStatus: '飞行模式状态',
    associateFence: '关联围栏',
    index: '序号',
    radius: '半径',
    bindFence: '绑定围栏',
    flightModeSetting: '飞行模式设置',
    pleaseEnterFlightModeDuration: '请输入飞行模式时长',
    pleaseEnterExitFlightModeBeforeCommunicationInterval: '请输入退出飞行模式前通信间隔',
    fenceInfo: '围栏信息',
    pleaseSelectAddress: '请选择地址',
    pleaseEnterRadius: '请输入半径',
    meter: '米',
    fenceManagement: '围栏管理',
    editFence: '编辑围栏',
    newFence: '新建围栏',
    findPassword: '找回密码',
    confirmAccount: '确认账号',
    resetPassword: '重置密码',
    resetComplete: '重置完成',
    pleaseEnterAccountBoundMobilePhoneNumberOrEmail: '请输入账号绑定的手机号码或者邮箱',
    nextStep: '下一步',
    pleaseEnterNewPassword: '请输入新密码',
    pleaseEnterNewPasswordAgain: '请再次输入新密码',
    previousStep: '上一步',
    goToLogin: '去登录',
    congratulations: '恭喜您',
    resetPasswordSuccess: '重置密码成功',
    shipmentID: 'ID',
    dataDetail: '数据详情',
    deviceTrack: '设备轨迹',
    coordinateTotalNumber: '坐标总数',
    clickCoordinateToGetAddress: '点击坐标获取地址',
    orderNo: '订单号',
    shipmentList: '发运列表',
    loading: '加载中',
    playSpeed: '播放速度',
    queryTrack: '查询轨迹',
    trackPlay: '轨迹播放',
    pause: '暂停',
    continue: '继续',
    stop: '停止',
    sensorTrackView: '传感器轨迹查看',
    lastHour: '最近1小时',
    last2Hours: '最近2小时',
    last3Hours: '最近3小时',
    last24Hours: 'Last 24 Hours',
    last3Days: '最近3天',
    lastWeek: '最近一周',
    last10Days: '最近10天',
    last15Days: '最近15天',
    lastMonth: '最近1个月',
    smsMargin: '语音余量',
    modifyParameters: '修改参数',
    setDeviceAlarm: '设备报警设置',
  },
  ...zhLocale,
};

export default cn;



// WEBPACK FOOTER //
// ./src/i18n/langs/cn.js